// extracted by mini-css-extract-plugin
export default {"root":"WDM-v","slider":"r0Xv_","item":"_2KvA7","last":"_32MWm"};